import React from 'react'
import { isFeatureEnabled, serverData, hasTreatmentName } from '../utils'
import { Message } from '@paypalcorp/worldready-react'
import {
  SHOPPING_SETTINGS_FLOW,
  SHOPPING_PRIVACY_FLOW,
} from '../constants/constants'
import { dataPrivacyConfig } from './data-privacy-data-platform'

const enabledForNative = serverData.isNative,
  isPublicProfile = serverData.isPublicProfile,
  isMerchantUser = serverData.isMerchantUser || false,
  enabledForPermission =
    !isMerchantUser && isFeatureEnabled('enabledForPermission'),
  enabledForManageCookies =
    isFeatureEnabled('enabledForManageCookies') && !enabledForNative,
  enabledForSearchPrivacy =
    hasTreatmentName('Trmt_Search_Privacy_Controls') &&
    isFeatureEnabled('enabledForSearchPrivacy') &&
    isPublicProfile,
  enabledForMarketing =
    !isMerchantUser && isFeatureEnabled('enabledForMarketing'),
  enabledForShopping =
    !isMerchantUser && isFeatureEnabled('enabledForShopping'),
  enabledForBlockedContacts =
    hasTreatmentName('Trmt_Blocked_Contacts_Controls') &&
    isFeatureEnabled('enabledForBlockedContacts'),
  enabledForManagePrivacySection =
    enabledForPermission ||
    enabledForManageCookies ||
    enabledForMarketing ||
    enabledForShopping ||
    enabledForSearchPrivacy ||
    enabledForBlockedContacts,
  isInFrame = serverData.isInFrame,
  subsectionComponent =
    serverData.selectedComponent === 'dw2' ? 'dw2' : 'default'

const privacySections = [
  {
    sectionId: 'privacySection',
    sectionName: <Message id="privacy.sectionName" />,
    isEnabled: enabledForManagePrivacySection,
    enabledCountries: [],
    hasElmoTreatment: true,
    subSections: [
      {
        subSectionId: 'permissions',
        title: <Message id="privacy.permissions.title" />,
        desc: <Message id="privacy.permissions.desc" />,
        iconName: dataPrivacyConfig.permission[subsectionComponent].iconName,
        linkClass: 'nemo-subSection-header subSection-header',
        hasElmoTreatment: true,
        featureEnabled: enabledForPermission, //rcs service
        navigateTo:
          '/myaccount/security/flow/permissions/thirdparty?flow=cmV0dXJuVXJsPS9teWFjY291bnQvcHJpdmFjeSZjYW5jZWxVcmw9L215YWNjb3VudC9wcml2YWN5',
        fptiClickData: {
          pgrp: 'main:dataprivacy:home',
          page: 'main:dataprivacy:home',
          link: 'permissions_given',
        },
      },
      {
        subSectionId: 'manageCookies',
        title: (
          <Message
            id={
              isMerchantUser
                ? 'privacy.merchant.cookies.title'
                : 'privacy.manageCookies.title'
            }
          />
        ),
        desc: <Message id="privacy.manageCookies.desc" />,
        iconName: !isMerchantUser
          ? dataPrivacyConfig.manageCookie[subsectionComponent].iconName
          : '',
        linkClass: 'nemo-subSection-header subSection-header',
        hasElmoTreatment: true,
        featureEnabled: enabledForManageCookies, //rcs service
        navigateTo: isInFrame && isMerchantUser
          ? `/myaccount/privacy/cookiePrefs?inframe=${isInFrame}`
          : '/myaccount/privacy/cookiePrefs',
        fptiClickData: {
          pgrp: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy'
            : 'main:dataprivacy:home',
          page: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy'
            : 'main:dataprivacy:home',
          pglk: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy|manage_cookies'
            : 'main:dataprivacy:home|manage_cookies',
          pgln: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy|manage_cookies'
            : 'main:dataprivacy:home|manage_cookies',
          comp: isMerchantUser ? 'bizmanagenodeweb' : 'privacynodeweb',
          link: 'manage_cookies',
        },
        action: <Message id="privacy.merchant.action.manage" />,
      },
      {
        subSectionId: 'interestMarketing',
        title: <Message id="privacy.marketing.title" />,
        desc: <Message id="privacy.marketing.desc" />,
        iconName: dataPrivacyConfig.marketing[subsectionComponent].iconName,
        linkClass: 'nemo-subSection-header subSection-header',
        hasElmoTreatment: true,
        featureEnabled: enabledForMarketing,
        modal: {
          name: 'interestMarketingModal',
        },
        fptiClickData: {
          pgrp: 'main:dataprivacy:home',
          page: 'main:dataprivacy:home',
          link: 'marketing_offers',
        },
      },
      {
        subSectionId: 'ppShopping',
        title: <Message id="privacy.shopping.title" />,
        desc: <Message id="privacy.shopping.desc" />,
        iconName: dataPrivacyConfig.shopping[subsectionComponent].iconName,
        linkClass: 'nemo-subSection-header subSection-header',
        hasElmoTreatment: true,
        featureEnabled: enabledForShopping,
        navigateTo: hasTreatmentName('Trmt_PayPal_Shopping_Controls')
          ? SHOPPING_PRIVACY_FLOW
          : SHOPPING_SETTINGS_FLOW,
        fptiClickData: {
          pgrp: 'main:dataprivacy:home',
          page: 'main:dataprivacy:home',
          link: 'pp_shopping',
        },
      },
      {
        subSectionId: 'searchPrivacy',
        title: <Message id="privacy.options.title" />,
        desc: <Message id="privacy.options.desc" />,
        iconName: !isMerchantUser
          ? dataPrivacyConfig.searchPrivacy[subsectionComponent].iconName
          : '',
        linkClass: 'nemo-subSection-header subSection-header',
        hasElmoTreatment: true,
        featureEnabled: enabledForSearchPrivacy,
        navigateTo: isInFrame && isMerchantUser
          ? `/myaccount/privacy/profiles/search?inframe=${isInFrame}`
          : '/myaccount/privacy/profiles/search',
        fptiClickData: {
          pgrp: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy'
            : 'main:dataprivacy:home',
          page: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy'
            : 'main:dataprivacy:home',
          pglk: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy|profiles_search'
            : 'main:dataprivacy:home|profiles_search',
          pgln: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy|profiles_search'
            : 'main:dataprivacy:home|profiles_search',
          comp: isMerchantUser ? 'bizmanagenodeweb' : 'privacynodeweb',
          link: 'profiles_search',
        },
        action: <Message id="privacy.merchant.action.update" />,
      },
      {
        subSectionId: 'blockedContacts',
        title: <Message id="privacy.blockedContacts.title" />,
        desc: <Message id="privacy.blockedContacts.desc" />,
        iconName: !isMerchantUser
          ? dataPrivacyConfig.blockedContacts[subsectionComponent].iconName
          : '',
        linkClass: 'nemo-subSection-header subSection-header',
        hasElmoTreatment: true,
        featureEnabled: enabledForBlockedContacts,
        navigateTo: isInFrame && isMerchantUser
          ? `/myaccount/transfer/homepage/contact-list/blocked-contacts?inframe=${isInFrame}`
          : '/myaccount/transfer/homepage/contact-list/blocked-contacts',
        fptiClickData: {
          pgrp: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy'
            : 'main:dataprivacy:home',
          page: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy'
            : 'main:dataprivacy:home',
          pglk: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy|blocked_contacts'
            : 'main:dataprivacy:home|blocked_contacts',
          pgln: isMerchantUser
            ? 'main:businessweb:profile:dataprivacy|blocked_contacts'
            : 'main:dataprivacy:home|blocked_contacts',
          comp: isMerchantUser ? 'bizmanagenodeweb' : 'privacynodeweb',
          link: 'blocked_contacts',
        },
        action: <Message id="privacy.merchant.action.update" />,
      },
    ],
  },
]

export default privacySections
